exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.a_c {\n  overflow: hidden;\n}\n.a_c .form {\n  margin-top: 0.09rem;\n  text-align: center;\n}\n.a_c .form .gray {\n  color: #84849A;\n}\n.a_c .form .ok {\n  padding-bottom: 0.28rem;\n  background-color: #fff;\n}\n.a_c .form .ok i {\n  font-size: 0.7rem;\n  color: #7E60FF;\n}\n.a_c .form .ok .s20 {\n  font-weight: bold;\n  margin-bottom: 0.07rem;\n}\n.a_c .form .button {\n  background-color: #f2f2f4;\n}\n.a_c .form .qr_code {\n  padding-top: 0.28rem;\n}\n.a_c .form .qr_code img {\n  width: 1.2rem;\n  height: 1.2rem;\n}\n", ""]);

// exports
